import {takeEvery} from "redux-saga/effects";
import { OPEN_NOTIFICATION } from "./notificationsConstants";
import { toast } from "react-toastify";

function openNotificationSaga({payload}) {
    const {content, options} = payload;
    toast(content, options);
}

export function* notificationsSagas() {
    yield takeEvery(OPEN_NOTIFICATION, openNotificationSaga);
}